import React, { useState } from 'react';
import { Card, Badge, Image, ListGroup, Modal, Button, Spinner, Form, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ModalShowPassword({ show, onHide, data, isLoadingButton }) {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);

    const handleCopyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(data?.password || '');
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy to clipboard:', err);
        }
    };

    const [copiedIdx, setCopiedIdx] = useState(null);

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('Password Information')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {data?.message && (
                    <div className="mb-4">
                        <h5 className="mb-2">{t('Message')}</h5>
                        <p className="text-muted">{data.message}</p>
                    </div>
                )}
                {Array.isArray(data?.secrets) && data.secrets.length > 0 && (
                    data.secrets.map((secret, idx) => (
                        <div className="mb-3" key={idx}>
                            <h5 className="mb-2">
                                {secret.target === 'username'
                                    ? t('Username')
                                    : secret.target === 'password'
                                    ? t('Password')
                                    : secret.target}
                            </h5>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    value={secret.value}
                                    readOnly
                                    className=""
                                />
                                <Button
                                    variant="outline-secondary"
                                    onClick={async () => {
                                        try {
                                            await navigator.clipboard.writeText(secret.value || '');
                                            setCopiedIdx(idx);
                                            setTimeout(() => setCopiedIdx(null), 2000);
                                        } catch (err) {
                                            console.error('Failed to copy to clipboard:', err);
                                        }
                                    }}
                                    disabled={!secret.value}
                                >
                                    {copiedIdx === idx ? (
                                        <>
                                            <i className="fe fe-check me-1"></i>
                                            {t('Copied')}
                                        </>
                                    ) : (
                                        <>
                                            <i className="fe fe-copy me-1"></i>
                                            {t('Copy')}
                                        </>
                                    )}
                                </Button>
                            </InputGroup>
                        </div>
                    ))
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onHide}>
                    {t('I have noted it down')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalShowPassword;